import { ButtonItem } from '@occc/ui-design-system';

import {
  FulfillmentChannel,
  FulfillmentChannelValue,
} from './fulfillment-channel-constraint.types';

export const FULFILLMENT_CHANNEL_LABELS: Record<FulfillmentChannelValue, string> = {
  [FulfillmentChannel.OrderAheadOnly]: 'Order Ahead Only',
  [FulfillmentChannel.InStoreOnly]: 'In Store Only',
};

export const fulfillmentChannelButtons: ButtonItem[] = Object.entries(
  FULFILLMENT_CHANNEL_LABELS,
).map(([value, title]) => ({ value, title }));
